import { fetchData } from '@tomra/client-side-http-client'
import { keycloak } from './authentication'

const config = {
  fetchNewToken: () => keycloak.updateToken(),
  getToken: () => keycloak.token ?? '', // token is always set after auth
  timeoutInMs: 60000
}

export const authenticatedFetchData = (url: string, options?: RequestInit) => fetchData(url, options, config)
